/* eslint-disable import/prefer-default-export */
/**
 *
 * @param {string} status
 * @returns {Boolean}
 */
export function isTransactionStatusPaid(status) {
  switch (status) {
    case 'coupon-success':
    case 'settled':
    case 'authorized':
    case 'submitted_for_settlement':
    case 'settling':
    case 'settlement_pending':
      return true;
    default:
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils/braintree-util.js